import React from 'react';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { displayMore } from '../../utils/apputils';
import { ImageGrid } from '../Home/Home.js';
import { users } from '../../store/actions';
import Spinner from '../Spinner/Spinner.js';

const Banner_Class = ({ currentCollection, collections }) => (
  <div>
    <div className="banner">
      <div className="container">
        <h1>
          Mockups from the <strong>{currentCollection} Collection</strong>
        </h1>
      </div>
    </div>
    <nav className="collections-nav">
      <div className="container">
        <h2 className="collections-nav-title">Browse collections:</h2>
        <ul>
          {collections.map(collection => {
            const { name } = collection;
            return (
              <li key={name} className="collections-nav-item">
                <Link to={'/collection/' + name}>{name}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  </div>
);

class CollectionBody_Class extends React.Component {
  displayMore = () => {
    const { dispatch } = this.props;
    displayMore(dispatch, 'collectionMoreButton');
  };

  render() {
    // Converting the state object keyed against UUID to an array of objects we can
    // iterate over with the image key as a prop
    const {
      imageCount,
      templates,
      collections,
      currentCollection,
      displayCountStatus
    } = this.props;
    const templateKeys = Object.keys(templates);
    const templateValues = Object.values(templates);
    const templateData = templateValues.map((valueObject, index) => {
      return { ...valueObject, key: templateKeys[index] };
    });
    const collection = collections.find(x => {
      return x.name === currentCollection;
    });
    const templatesInCollection = templateData.filter(template => {
      return collection.templates.includes(template.key);
    });
    return (
      <Grid>
        <ImageGrid
          width={3}
          templateData={templatesInCollection}
          imageCount={imageCount}
        />
        <div className="pagination">
          <button
            id="collection-more-button"
            className="btn btn-secondary btn-bevel"
            onClick={this.displayMore}
            disabled={templatesInCollection.length <= imageCount}
          >
            {displayCountStatus !== users.types.DISPLAYING_MORE && (
              <span>More</span>
            )}
            {displayCountStatus === users.types.DISPLAYING_MORE && (
              <Spinner type="moreButton" />
            )}
          </button>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  templates: state.s3Templates.templatesJSON.templates,
  collections: state.s3Templates.templatesJSON.collections,
  imageCount: state.users.collectionDisplayCount,
  displayCountStatus: state.users.displayCountStatus
});

const Banner = connect(mapStateToProps)(Banner_Class);
const CollectionBody = connect(mapStateToProps)(CollectionBody_Class);

const Feature = connect((state, ownprops) => ({
  name: ownprops.match.params.name
}))(({ name }) => {
  return (
    <div>
      <Banner currentCollection={name} />
      <CollectionBody currentCollection={name} />
    </div>
  );
});

export default Feature;



// WEBPACK FOOTER //
// ./src/comps/Collection/Collection.js